import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import { FormulaType } from '../../constants/formulaType';

import { ParsedLabelsType } from '../../models/label.model';

import BannerForAlternates from './BannerForAlternates';

interface FormulaTopBannerProps {
    is_in_edit_mode?: boolean;
    parsedLabels: ParsedLabelsType;
    formulaType?: FormulaType;
}
const FormulaTopBanner: React.FC<FormulaTopBannerProps> = ({
    is_in_edit_mode,
    formulaType,
    parsedLabels,
}) => {
    const hasLabels = parsedLabels.length > 0;

    return (
        <Toast>
            {is_in_edit_mode && (
                <>
                    You are currently in the Edit mode. Changes are saved
                    automatically. Click “Proceed sending” button to exit
                    editing mode.
                    {hasLabels && (
                        <BannerForAlternates
                            suggestedLabels={parsedLabels}
                        ></BannerForAlternates>
                    )}
                </>
            )}

            {hasLabels && !is_in_edit_mode && formulaType && (
                <BannerForAlternates
                    suggestedLabels={parsedLabels}
                ></BannerForAlternates>
            )}
        </Toast>
    );
};

export default FormulaTopBanner;
const Toast = styled.div({
    color: aampeTheme.colors.solidA02,
    display: 'flex',
    flexDirection: 'column',
    width: '1172px',
    padding: aampeTheme.spacing4(1, 3),
    justifyContent: 'center',
    alignItems: 'center',
    gap: aampeTheme.spacing4(1),
    flexShrink: 0,
    borderRadius: aampeTheme.borderRadius.message,
    background: '#E5F2FF',
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.medium,
    lineHeight: aampeTheme.size.lineHeight.small,
    margin: aampeTheme.spacing4(3, 0, 4, 0),
});
